import React from "react";

function FileIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            fill="none"
            viewBox="0 0 40 40"
        >
            <path
                stroke="var(--color-neutral-dark-darker)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.5"
                d="M24.167 3.333H10a3.333 3.333 0 00-3.333 3.333v26.667A3.333 3.333 0 0010 36.666h20a3.333 3.333 0 003.333-3.333V12.5l-9.166-9.167z"
            ></path>
            <path
                stroke="var(--color-neutral-dark-darker)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.5"
                d="M23.333 3.333v10h10M26.667 21.667H13.333M26.667 28.333H13.333M16.667 15h-3.334"
            ></path>
        </svg>
    );
}

export default FileIcon;
